import React from 'react';
import { Theme } from '@mui/material/styles';
import useTheme from '@mui/material/styles/useTheme';

import makeStyles from '@mui/styles/makeStyles';
import SplitPageTitle from 'components/Layout/SplitPageTitle';
import { CGCardSize } from '../Product/CardMaster';
import useMediaQuery from '@mui/material/useMediaQuery';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/ArrowForward';
import { Link as RouterLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import CardMaster from 'components/Product/CardMaster';
import Stack from '@mui/material/Stack';
import clxs from 'classnames';

interface CardSectionProps {
  title: string;
  subtitle?: string;
  cardImage?: string;
  sectionImage: string;
  hasBlurBackground?: boolean;
  buttonText: string;
  redirectPath?: string;
}

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      padding: theme.spacing(1, 0),
      position: 'relative',
      minHeight: 680,
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(3, 0),

        minHeight: 780,
      },
    },
    splash: {
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      zIndex: -1,
    },
    blur: {
      opacity: '0.5',
      filter: 'blur(6px)',
    },
  }),
  { name: 'CardSection' },
);

const CardSection: React.FC<CardSectionProps> = ({ title, subtitle = '', cardImage, sectionImage, hasBlurBackground, buttonText, redirectPath }) => {
  const classes = useStyles();
  const theme = useTheme();
  const cardSize: CGCardSize = useMediaQuery(theme.breakpoints.down('md')) ? 'small' : 'large';
  return (
    <div className={classes.root}>
      <div
        className={clxs(classes.splash, hasBlurBackground && classes.blur)}
        style={{
          backgroundImage: 'url(' + sectionImage + ')',
        }}
      />
      <SplitPageTitle title={title} subtitle={subtitle} fullWidth sx={{ paddingX: { xs: 3, sm: 5 }, marginBottom: 12 }} />
      <Stack alignItems="center" spacing={2} sx={{ paddingTop: { xs: 1 } }}>
        {cardImage && <CardMaster image={cardImage} size={cardSize} showPrice={50} />}
      </Stack>
      <Box sx={{ position: 'absolute', bottom: '60px', left: 0, right: 0, textAlign: 'center' }}>
        <Button
          component={RouterLink} // It is a link...
          to={redirectPath ? redirectPath : '/landing/mastercard/'}
          size={'large'}
          color="secondary"
          variant="outlined"
          endIcon={<SendIcon />}
        >
          {buttonText}
        </Button>
      </Box>
    </div>
  );
};

export default CardSection;
